import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "./Hero.css";

const SLIDES = [
  {
    image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=1200&q=75",
    title: "New Lawn\nCollection 2025",
    cta: "SHOP NOW!!",
    ctaLink: "/shop?category=lawn",
  },
  {
    image: "https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?w=1200&q=75",
    title: "Festive\nFormals",
    cta: "SHOP NOW!!",
    ctaLink: "/shop?category=stitched",
  },
  {
    image: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=1200&q=75",
    title: "Premium\nLinen",
    cta: "SHOP NOW!!",
    ctaLink: "/shop?category=linen",
  },
  {
    image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?w=1200&q=75",
    title: "Kurtis &\nCo-ords",
    cta: "SHOP NOW!!",
    ctaLink: "/shop?category=kurtis",
  },
  {
    image: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=1200&q=75",
    title: "Wedding\nVibes",
    cta: "SHOP NOW!!",
    ctaLink: "/shop?category=occasion",
  },
];

export default function Hero() {
  const [active, setActive] = useState(0);
  const [animating, setAnimating] = useState(false);

  const goTo = useCallback((index) => {
    if (animating) return;
    setAnimating(true);
    setActive(index);
    setTimeout(() => setAnimating(false), 600);
  }, [animating]);

  const next = useCallback(() => goTo((active + 1) % SLIDES.length), [active, goTo]);
  const prev = useCallback(() => goTo((active - 1 + SLIDES.length) % SLIDES.length), [active, goTo]);

  useEffect(() => {
    const t = setInterval(next, 5000);
    return () => clearInterval(t);
  }, [next]);

  return (
    <div className="hero-wrapper">
      <section className="hero">
        {/* Slides */}
        {SLIDES.map((s, i) => (
          <div key={i} className={`hero-slide ${i === active ? "active" : ""}`}>
            <img
              src={s.image}
              alt={s.title}
              loading={i === 0 ? "eager" : "lazy"}
              decoding="async"
            />
          </div>
        ))}

        {/* Left overlay with text */}
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1>{SLIDES[active].title}</h1>
          <Link to={SLIDES[active].ctaLink} className="hero-cta">
            {SLIDES[active].cta}
          </Link>
        </div>

        {/* Arrows */}
        <button className="hero-arrow left" onClick={prev}><FiChevronLeft /></button>
        <button className="hero-arrow right" onClick={next}><FiChevronRight /></button>
      </section>

      {/* Dots below carousel */}
      <div className="hero-dots">
        {SLIDES.map((_, i) => (
          <button key={i} className={`hero-dot ${i === active ? "active" : ""}`} onClick={() => goTo(i)} />
        ))}
      </div>
    </div>
  );
}
